import { graphql } from "gatsby";
import * as React from "react";
import {
  Base, Button, HeroBody, Flex, Heading, Section, Text,
  Icon
} from "./ui";
import * as styles from "./ui.css";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import ReactHtmlParser from 'react-html-parser';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons'

const CompetitorTopText = (props) => {
  return (
    <div style={{ display: 'flex', alignItems: 'end', height: 52, marginBottom: 16, width: '100%' }}>
      <Text variant={'competitorName'}>
        {props.children}
      </Text>
    </div>
  )
}

const ViewListData = (props) => {
  return (
    <Base as='div' cx={props.checker ? [styles.viewListDataChecker] : [styles.viewListData]}>
      {props.children}
    </Base>
  )
}

const FeatureName = (props) => {
  return (
    <Base as='div' cx={[props.first ? styles.featureNameFirst : styles.featureName]}>
      <Base as='div' cx={[styles.featureNameText]}>
        {props.children.split(",").map((text, i) => {
          if (i === 0) {
            return <strong key={'feature_name_strong_' + i} style={{ color: '#621AE0', fontWeight: 500 }}>{text}</strong>
          } else {
            return "," + text;
          }
        })}
      </Base>
    </Base>
  )
}

const CheckedImage = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.9961 8.26101V8.99701C16.9951 10.7221 16.4365 12.4007 15.4036 13.7825C14.3706 15.1642 12.9187 16.175 11.2644 16.6641C9.61004 17.1533 7.8419 17.0945 6.22367 16.4967C4.60544 15.8988 3.22382 14.7939 2.28486 13.3467C1.34591 11.8994 0.899927 10.1875 1.01344 8.46606C1.12694 6.74466 1.79386 5.10607 2.91472 3.79467C4.03558 2.48327 5.55032 1.56932 7.23304 1.18913C8.91577 0.808938 10.6763 0.98288 12.2521 1.68501" stroke="#00A385" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M16.9962 2.59705L8.99619 10.605L6.59619 8.20504" stroke="#00A385" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

const UncheckedImage = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      version="1.1"
      viewBox="0 0 32 32"
    >
      <path
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.875"
        d="M15.992 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.285 0-15 6.716-15 15 0 8.284 6.715 15 15 15z"
      ></path>
      <path
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.875"
        d="M5.387 5.395l21.21 21.21"
      ></path>
    </svg>
  );
}

const FeatureChecker = ({ first, last, checked }) => {
  return (
    <Base as='div' cx={first ? [styles.featureCheckerFirst] : (last ? [styles.featureCheckerLast] : [styles.featureChecker])}>
      <div style={{ width: 30, height: 30, marginLeft: 'auto', marginRight: 'auto' }}>
        {
          checked ?
            <CheckedImage />
            :
            <UncheckedImage />
        }
      </div>
    </Base>
  )
}

export default function CompetitorsList(props) {
  return (
    <Section cx={[styles.competitorsSection]}>
      <Flex gap={0} cx={[styles.competitorsFlexWrapper]}>
        <Base as='div' cx={[styles.competitorsLeftWrapper]}>
          <Base as='div' cx={[styles.leftBackContainer]}>
            <Base as='div' cx={[styles.leftBackContainerFitness]} />
            <Base as='div' cx={[styles.leftBackContainerMind]} />
            <Base as='div' cx={[styles.leftBackContainerMedical]} />
            <Base as='div' cx={[styles.leftBackContainerFinancial]} />
          </Base>
          <Base
            as={GatsbyImage}
            placeholder='none'
            alt={props.screen.alt}
            image={getImage(props.screen.gatsbyImageData)}
            className={[styles.screenImage]}
          />
        </Base>
        <Base as='div' cx={[styles.competitorsRightWrapper]}>
          <Text variant={'headingHowItWorks'}>
            {ReactHtmlParser(props.heading)}
          </Text>
          <Text variant={'kickerHowItWorks'}>
            {props.kicker}
          </Text>
          {props.competitors.map((item) => {
            return (
              <HeroBody>
                {item.name}
              </HeroBody>
            )
          })}
          <Button to={'#heroForm'} variant='primary' style={{ marginTop: 0, marginBottom: 16, padding: '12px 16px', width: 'fit-content', display: 'block' }}>
            Contrate para sua empresa <FontAwesomeIcon icon={faArrowRightLong} />
          </Button>
          <Text variant={'kickerHowItWorksBottom'}>
            {props.kicker2}
          </Text>
          <Base as="div" cx={[styles.flexCompetitorsList]}>
            {props.competitorFeatures.map((item) => {
              return (
                <Base as="div" cx={[styles.checkedText]}>

                  <Base as="div" cx={[styles.checkedIcon]}>
                  <CheckedImage />
                  </Base>
                  <Text variant="featureItem">
                    {item.name}
                  </Text>
                </Base>
              )
            })}
          </Base>
        </Base>
      </Flex>
    </Section>
  )
}

export const query = graphql`
  fragment HomepageCompetitorsListContent on HomepageCompetitorsList {
    id
    kicker
    kicker2
    heading
    competitors {
      id
      name
    }
    competitorFeatures {
      id
      name
      competitorsCheck {
        id
        check
      }
    }
    screen {
      id
      gatsbyImageData
      alt
    }
  }
`
